import type { RequestHeader } from '@/types/base';

export interface KPIConsecutiveFailPeriodItem {
  title: string;
  batDau: string;
  ketThuc: string;
  reason: string;
  icon?: string | null;
  phanTramTiTrong: number;
}

export interface KPIConsecutiveFailAlertItem {
  id: string;
  idPhuTrach: string;
  loaiDoiTuong: string;
  tenPhuTrach?: string | null;
  idKPI?: string | null;
  idChiTieu: string;
  tenKPI?: string | null;
  tanSuat: number;
  streak: number;
  kyBatDau?: string | null;
  kyKetThuc?: string | null;
  kyKichHoat?: string | null;
  trangThai: string;
  periods: KPIConsecutiveFailPeriodItem[];
}

export interface KPIConsecutiveFailOwnerGroup {
  id: string;
  ten?: string | null;
  loaiDoiTuong: string;
  alerts: KPIConsecutiveFailAlertItem[];
}

export interface KPIConsecutiveFailScanResponse {
  idBoPhan: string;
  year: number;
  threshold: number;
  enabled: boolean;
  self: KPIConsecutiveFailAlertItem[];
  employees: KPIConsecutiveFailOwnerGroup[];
  childDepts: KPIConsecutiveFailOwnerGroup[];
  totalCount: number;
  activeCount: number;
}

export interface KPIConsecutiveFailScanRequest {
  requestHeader?: RequestHeader | null;
  idBoPhan?: string;
  year?: number;
  threshold?: number;
  sendNotification?: boolean;
  phanHe?: string;
}

export interface KPIConsecutiveFailDismissRequest {
  id: string;
  lyDo?: string;
  phanHe?: string;
}

export const emptyKPIConsecutiveFailScanResponse = (): KPIConsecutiveFailScanResponse => ({
  idBoPhan: '',
  year: new Date().getFullYear(),
  threshold: 3,
  enabled: true,
  self: [],
  employees: [],
  childDepts: [],
  totalCount: 0,
  activeCount: 0,
});
